import React from 'react';
import { Tabs } from 'flowbite-react';
import Image from 'next/image';
import MWSVG from '../common/svg';

const AiAgentTechStack = () => {
    return (
        <div
            className="section-py bg-grey dark:bg-black overflow-x-hidden border-b"
            style={{
                borderImageSource: 'linear-gradient(270deg, rgba(60, 69, 97, 0) 0%, #3C4561 50%, rgba(60, 69, 97, 0) 100%)',
                borderImageSlice: 1,
            }}
        >
            <div className="container xl:container mx-auto">
                <div className="row grid lg:grid-cols-12 mb-11">
                    <div className="lg:col-span-12 text-center">
                        <h2 className="dark:text-white">Tech Stack</h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12 technologies-tools-tab overflow-x-hidden">
                    <div className="lg:col-span-12 grid">
                        <Tabs.Group className="items-center	tab-items" aria-label="underline tabs" style="underline">
                            <Tabs.Item active title="LLMs & Models">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic-openai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OpenAI"
                                            title="OpenAI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">OpenAI</p>
                                    </div>
                                    <div className="tech-box">
                                        <MWSVG id="ic-Anthropic-Claude" svgClassName="!w-auto !h-[50px] mb-2.5" />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Anthropic</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_azure.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Azure"
                                            title="Azure"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Azure</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/technologies-icon/hugging-face.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Hugging Face"
                                            title="Hugging Face"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Hugging Face</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_mistralai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Mistral AI"
                                            title="Mistral AI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Mistral AI</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Orchestration Frameworks">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_langchain.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LangChain"
                                            title="LangChain"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LangChain</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_langgraph.svg"
                                            className="img-fluid mb-2.5 !h-10"
                                            alt="LangGraph"
                                            title="LangGraph"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LangGraph</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_llamaindex.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LlamaIndex"
                                            title="LlamaIndex"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LlamaIndex</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_crewai.svg"
                                            className="img-fluid mb-2.5"
                                            alt="CrewAI"
                                            title="CrewAI"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">CrewAI</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_autogen.svg"
                                            className="img-fluid mb-2.5"
                                            alt="AutoGen"
                                            title="AutoGen"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">AutoGen</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Vector Databases">
                                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_pinecone.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Pinecone"
                                            title="Pinecone"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Pinecone</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_milvus.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Milvus"
                                            title="Milvus"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Milvus</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_chroma.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Chroma"
                                            title="Chroma"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Chroma</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Integration & Automation">
                                <div className="row grid xl:grid-cols-4 lg:grid-cols-4 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_mcp.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Model Context Protocol (MCP)"
                                            title="Model Context Protocol (MCP)"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">
                                            Model Context Protocol (MCP)
                                        </p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_zapier.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Zapier"
                                            title="Zapier"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Zapier</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_powerautomate.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Power Automate"
                                            title="Power Automate"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Power Automate</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_uipath.svg"
                                            className="img-fluid mb-2.5"
                                            alt="UiPath"
                                            title="UiPath"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">UiPath</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                            <Tabs.Item title="Monitoring & Security">
                                <div className="row grid xl:grid-cols-5 lg:grid-cols-5 md:grid-cols-3 grid-cols-2">
                                    <div className="tech-box">
                                        <Image
                                            src="/img/llms-aiml/svg/ic_langsmith.svg"
                                            className="img-fluid mb-2.5"
                                            alt="LangSmith"
                                            title="LangSmith"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">LangSmith</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_prometheus.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Prometheus"
                                            title="Prometheus"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Prometheus</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_grafana.svg"
                                            className="img-fluid mb-2.5"
                                            alt="Grafana"
                                            title="Grafana"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">Grafana</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/sso.svg"
                                            className="img-fluid mb-2.5"
                                            alt="OAuth 2.0 & IAM/SSO"
                                            title="OAuth 2.0 & IAM/SSO"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">OAuth 2.0 & IAM/SSO</p>
                                    </div>
                                    <div className="tech-box">
                                        <Image
                                            src="/img/ai-agent/svg/ic_soc_compliance.svg"
                                            className="img-fluid mb-2.5"
                                            alt="SOC 2 & GDPR Compliance"
                                            title="SOC 2 & GDPR Compliance"
                                            height={50}
                                            width={50}
                                            loading="lazy"
                                        />
                                        <p className="text-base font-semibold mb-0 dark:text-white">SOC 2 & GDPR Compliance</p>
                                    </div>
                                </div>
                            </Tabs.Item>
                        </Tabs.Group>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AiAgentTechStack;
